/* global Quill, Metafans_JS */

/**
 * Initializes the bbPress Quill editor and its submission handling.
 */
export function init() {
    let quillEditor;

    if (jQuery("#th_bbp_reply").length) {
        quillEditor = new Quill("#th_bbp_reply", {
            modules: {
                toolbar: [
                    [{ header: [1, 2, 3, false] }],
                    ["bold", "italic", "underline"],
                    ["link", "image"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["clean"],
                ],
            },
            placeholder: "Your topic description...",
            theme: "snow", // or 'bubble'
        });

        const insertToEditor = (url) => {
            const range = quillEditor.getSelection();
            quillEditor.insertEmbed(range.index, "image", url);
        };

        const selectLocalImage = () => {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/*");
            input.click();

            input.onchange = async () => {
                const file = input.files[0];
                if (/^image\//.test(file.type)) {
                    const formData = new FormData();
                    formData.append("file", file);
                    formData.append("action", "upload_quill_image"); // WordPress AJAX hook

                    const response = await fetch("/wp-admin/admin-ajax.php", {
                        method: "POST",
                        body: formData,
                    });

                    const json = await response.json();
                    if (json.success && json.data.url) {
                        insertToEditor(json.data.url);
                    }
                }
            };
        };

        quillEditor.getModule("toolbar").addHandler("image", () => {
            selectLocalImage();
        });
    }

    // BBPRESS submit reply ajax
    jQuery(document).on("click", "#th_bbp_reply_submit", function (e) {
        e.preventDefault();
        const that = jQuery(this);

        // Guard-close/bailout if editor is not initialized or is blank
        if (!quillEditor || !quillEditor.getText().trim()) return;

        that.text("Please Wait...");
        that.attr("disabled", true);
        const $form = jQuery(".th-bbpress-reply-form");
        const data = $form.serializeArray();
        const text = quillEditor.root.innerHTML; // Use innerHTML to preserve formatting
        data.push({ name: "bbp_reply_content", value: text });
        const nonceField = $form.find('input[name="bbp_reply_nonce"], input[name="_wpnonce"]').first();

        const newData = {};
        data.forEach(item => {
            newData[item.name] = item.value;
        });
        newData['action'] = 'bbp-new-reply';
        newData['redirect_to'] = window.location.href;
        if (nonceField.length) {
            newData['nonce'] = nonceField.val();
        }

        jQuery.ajax({
            url: Metafans_JS.ajaxurl,
            type: "POST",
            dataType: "json",
            data: {
                action: "th_bbp_new_reply",
                data: newData,
                nonce: nonceField.length ? nonceField.val() : undefined
            },
            success: function (res) {
                if (!res || res.success === false) {
                    const errors = res && res.data && res.data.errors ? res.data.errors : ['Something went wrong'];
                    jQuery(".th_bpp_reply_messages").html('<span class="errors">' + errors.toString() + "</span>");
                    that.attr("disabled", false);
                } else {
                    const legacy = res.success && typeof res.success === 'object' ? res.success : null;
                    const msg = legacy && legacy.text ? legacy.text : (res.data && res.data.text ? res.data.text : 'Replied Successfully');
                    const goto = legacy && legacy.goto ? legacy.goto : (res.data && res.data.goto ? res.data.goto : '');
                    const html = legacy && legacy.html ? legacy.html : (res.data && res.data.html ? res.data.html : '');
                    const messagesEl = jQuery(".th_bpp_reply_messages");
                    messagesEl.html('<span class="success">' + msg + "</span>");
                    if (html) {
                        let repliesBody = document.querySelector('#bbpress-forums ul.bbp-replies li.bbp-body');
                        if (!repliesBody) {
                            const forumsWrap = document.querySelector('#bbpress-forums');
                            if (forumsWrap) {
                                const ul = document.createElement('ul');
                                ul.className = 'forums bbp-replies';
                                const bodyLi = document.createElement('li');
                                bodyLi.className = 'bbp-body';
                                ul.appendChild(bodyLi);
                                const formEl = document.querySelector('.th-bbpress-reply-form');
                                if (formEl && formEl.parentElement) {
                                    formEl.parentElement.insertBefore(ul, formEl);
                                } else {
                                    forumsWrap.appendChild(ul);
                                }
                                repliesBody = bodyLi;
                            }
                        }
                        if (repliesBody) {
                            const temp = document.createElement('div');
                            temp.innerHTML = html.trim();
                            const newReply = temp.firstElementChild;
                            if (newReply) {
                                newReply.style.opacity = '0';
                                repliesBody.appendChild(newReply);
                                requestAnimationFrame(() => {
                                    newReply.style.transition = 'opacity 300ms ease';
                                    newReply.style.opacity = '1';
                                    newReply.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                });
                                if (quillEditor) quillEditor.setContents([]);
                                that.attr("disabled", false);
                                messagesEl.empty();
                            } else if (goto) {
                                window.location.href = goto;
                            } else {
                                window.location.reload();
                            }
                        } else if (goto) {
                            window.location.href = goto;
                        } else {
                            window.location.reload();
                        }
                    } else if (goto) {
                        window.location.href = goto;
                    } else {
                        window.location.reload();
                    }
                }
                that.text("Submit");
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.error(xhr);
                that.text("Submit");
                that.attr("disabled", false);
            },
        });
    });
}
